import React, {Fragment, memo} from 'react';
import {useSelector} from 'react-redux';

import {translate} from '@mapsight/ui/src/js/helpers/i18n';
import getFeatureProperty from '@mapsight/ui/src/js/helpers/get-feature-property';

import {featureSelectPreselectSelector} from '../../stade/store/selectors';

import Link from '../../stade/components/link';

import StarsField from './stars-field';


// TODOs:
// - Wenn eine Bewertung schon abgegeben wurde: die vergebenen Sterne in Klein und die ersten
//   Zeichen des Kommentar + Knopf 'ändern'

export default memo(function Stars({short, feature}) {
	const preselectFeature =  useSelector(featureSelectPreselectSelector);

	feature = feature || preselectFeature;

	if (feature === null) {
		return null;
	}

	const value = getFeatureProperty(feature, 'ratings')?.totalRating;
	const content = (<StarsField value={value} big={!short} />);

	if(short) {
		return (
			<Link to={{
				pathname: `/${feature.id}`,
				state: {ratings: true}
			}}>{content}</Link>
		);
	}

	return (
		<Fragment>
			{content}
			<ul>
				<li className={`stade-widget__rating__stars`} >
					<Link to={{
						pathname: `/${feature.id}`,
						state: {ratingForm: true}
					}}>
						{translate('ratings.showform')}
					</Link>
				</li>
				<li>
					<Link to={{
						pathname: `/${feature.id}`,
						state: {ratings: true}
					}}>
						{translate('ratings.showall')}
					</Link>
				</li>
			</ul>
		</Fragment>
	);
});
